<script>
export default {
  name: 'CategoryDescription',
  props: {
    description: { required: true, type: String },
  },
};
</script>

<template>
  <div v-html="description" class="dynamic-content" />
</template>

<style lang="scss" scoped>
.dynamic-content:deep(a) {
  text-decoration: underline;
}
</style>
